<template>
  <div>
    <v-card
      :height="compound ? '280px' : '340px'"
      :flat="compound"
      :outlined="compound"
    >
      <v-toolbar outlined flat style="height: 60px" v-if="!compound">
        <v-toolbar-title>
          <v-subheader
            class="text-uppercase font-weight-bold primary--text pl-0"
            >{{ graph.name }}</v-subheader
          >
          <v-subheader
            v-if="customActive"
            class="text-caption text-uppercase font-weight-bold primary--text mt-n6 pl-0"
            >{{ text }}</v-subheader
          >
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <div v-if="graph.props[0] === 'kwht'">
          <v-btn
            text
            x-small
            v-model="kwh.btn0"
            :color="kwh.btn0 ? 'accent' : 'grey darken-3'"
            @click="setGraphData(graph.props[0], items[0])"
          >
            {{ items[0] }}
          </v-btn>
          <v-btn
            text
            x-small
            v-model="kwh.btn1"
            :color="kwh.btn1 ? 'accent' : 'grey darken-3'"
            @click="setGraphData(graph.props[0], items[1])"
          >
            {{ items[1] }}
          </v-btn>
          <v-btn
            text
            x-small
            v-model="kwh.btn2"
            :color="kwh.btn2 ? 'accent' : 'grey darken-3'"
            @click="setGraphData(graph.props[0], items[2])"
          >
            {{ items[2] }}
          </v-btn>
          <v-btn
            text
            x-small
            v-model="kwh.btn3"
            :color="kwh.btn3 ? 'accent' : 'grey darken-3'"
            @click="setGraphData(graph.props[0], items[3])"
          >
            {{ items[3] }}
          </v-btn>
        </div>
        <div v-if="graph.props[0] === 'watts'">
          <v-btn
            text
            x-small
            v-model="w.btn0"
            :color="w.btn0 ? 'accent' : 'grey darken-3'"
            @click="setGraphData(graph.props[0], items[0])"
          >
            {{ items[0] }}
          </v-btn>
          <v-btn
            text
            x-small
            v-model="w.btn1"
            :color="w.btn1 ? 'accent' : 'grey darken-3'"
            @click="setGraphData(graph.props[0], items[1])"
          >
            {{ items[1] }}
          </v-btn>
          <v-btn
            text
            x-small
            v-model="w.btn2"
            :color="w.btn2 ? 'accent' : 'grey darken-3'"
            @click="setGraphData(graph.props[0], items[2])"
          >
            {{ items[2] }}
          </v-btn>
        </div>
        <div v-if="graph.props[0] === 'volts'">
          <v-btn
            text
            x-small
            v-model="v.btn0"
            :color="v.btn0 ? 'accent' : 'grey darken-3'"
            @click="setGraphData(graph.props[0], items[0])"
          >
            {{ items[0] }}
          </v-btn>
          <v-btn
            text
            x-small
            v-model="v.btn1"
            :color="v.btn1 ? 'accent' : 'grey darken-3'"
            @click="setGraphData(graph.props[0], items[1])"
          >
            {{ items[1] }}
          </v-btn>
          <v-btn
            text
            x-small
            v-model="v.btn2"
            :color="v.btn2 ? 'accent' : 'grey darken-3'"
            @click="setGraphData(graph.props[0], items[2])"
          >
            {{ items[2] }}
          </v-btn>
        </div>
        <div v-if="graph.props[0] === 'amps'">
          <v-btn
            text
            x-small
            v-model="a.btn0"
            :color="a.btn0 ? 'accent' : 'grey darken-3'"
            @click="setGraphData(graph.props[0], items[0])"
          >
            {{ items[0] }}
          </v-btn>
          <v-btn
            text
            x-small
            v-model="a.btn1"
            :color="a.btn1 ? 'accent' : 'grey darken-3'"
            @click="setGraphData(graph.props[0], items[1])"
          >
            {{ items[1] }}
          </v-btn>
          <v-btn
            text
            x-small
            v-model="a.btn2"
            :color="a.btn2 ? 'accent' : 'grey darken-3'"
            @click="setGraphData(graph.props[0], items[2])"
          >
            {{ items[2] }}
          </v-btn>
        </div>
        <v-btn
          text
          color="grey"
          fab
          small
          @click="retrieveData(graph.props[0])"
        >
          <v-icon>mdi-cog</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <chart_
          v-if="graph.graph == CHART"
          :data="data"
          :type="graph.type"
          :compound="compound != undefined"
          :title="graph.name"
          :ytitle="ytitle"
          :historic="historic != undefined"
          :infoRetrieved="infoRetrieved"
          height="80%"
        />
        <widget_ v-if="graph.graph == WIDGET" :data="data" :graph="graph" />
      </v-card-text>
    </v-card>
    <v-dialog v-model="edit" persistent max-width="600">
      <v-card>
        <v-toolbar :elevation="0" color="primary" dark>
          <v-toolbar-title>Display data</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text class="pt-6">
          <v-card outlined>
            <v-card-text>
              <v-row>
                <v-col cols="12" md="4" class="ma-auto">From:</v-col>
                <v-col cols="12" md="8">
                  <v-menu
                    ref="start"
                    v-model="start.open"
                    :close-on-content-click="false"
                    :return-value.sync="start.date"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="start.date"
                        dense
                        solo
                        flat
                        outlined
                        hide-details
                        prepend-inner-icon="mdi-calendar"
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      locale="es-es"
                      v-model="start.date"
                      no-title
                      scrollable
                      @change="selectDate(start.date, 'start')"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" md="4" class="mt-2" v-if="type === 'hour'"
                  >Start:</v-col
                >
                <v-col cols="12" md="8" v-if="type === 'hour'">
                  <v-text-field
                    v-model="start.time"
                    flat
                    solo
                    outlined
                    dense
                    type="time"
                  ></v-text-field>
                </v-col>
                <v-col
                  cols="12"
                  md="4"
                  style="position: relative; top: -25px"
                  class="mt-2"
                  v-if="type === 'hour'"
                  >End:</v-col
                >
                <v-col
                  cols="12"
                  md="8"
                  style="position: relative; top: -25px"
                  v-if="type === 'hour'"
                >
                  <v-text-field
                    v-model="end.time"
                    flat
                    solo
                    outlined
                    dense
                    type="time"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row v-if="type === 'day'">
                <v-col cols="12" md="4" class="ma-auto">To:</v-col>
                <v-col cols="12" md="8">
                  <v-menu
                    ref="end"
                    v-model="end.open"
                    :close-on-content-click="false"
                    :return-value.sync="end.date"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="end.date"
                        dense
                        solo
                        flat
                        outlined
                        hide-details
                        prepend-inner-icon="mdi-calendar"
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      locale="es-es"
                      v-model="end.date"
                      no-title
                      scrollable
                      @change="selectDate(end.date, 'end')"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
            </v-card-text>
            <transition name="shake" v-if="error">
              <v-card-text
                class="text-right shake ml-n1 mt-n7 red--text"
                :class="unit === 'kwht' ? '' : 'only'"
                >{{ errorMsgs[idx] }}</v-card-text
              >
            </transition>
          </v-card>
        </v-card-text>
        <v-card-actions>
          <p v-if="show" class="primary--text ml-4">
            This operation might take some minutes
          </p>
          <v-spacer></v-spacer>
          <v-btn
            v-if="type === 'day'"
            :loading="processing"
            :disabled="start.date === null || end.date === null"
            color="accent"
            small
            @click="setDates()"
            >Save</v-btn
          >
          <v-btn
            v-else
            :loading="processing"
            :disabled="start.date === null"
            color="accent"
            small
            @click="setDates()"
            >Save</v-btn
          >
          <v-btn color="blue-grey lighten-1" dark small @click="reset()"
            >Cancel</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import moment from "moment";
import { KWH, COLUMS } from "./props-types";
import { mapActions, mapGetters, mapState } from "vuex";
import { CHART, WIDGET } from "./props-types";
import { Readings } from "../../api";
import chart_ from "./Chart";
import widget_ from "./Widget";
export default {
  name: "GraphContainer",
  components: { chart_, widget_ },
  props: [
    "meter",
    "graph",
    "historic",
    "width",
    "compound",
    "ytitle",
    "datacomp",
  ],
  data() {
    return {
      data: {},
      datafront: {},
      rawDataDaily: {},
      dataAll: {},
      data15: {},
      data7: {},
      datacurr: {},
      items: [],
      vData: { vm60: {}, vh12: {}, vAll: {}, vCustom: {} },
      aData: { am60: {}, ah12: {}, aAll: {}, aCustom: {} },
      wData: { wm60: {}, wh12: {}, wAll: {}, wCustom: {} },
      kwh: { btn0: true, btn1: false, btn2: false, btn3: false },
      w: { btn0: false, btn1: false, btn2: true },
      v: { btn0: false, btn1: false, btn2: true },
      a: { btn0: false, btn1: false, btn2: true },
      dayRecords: {},
      halfDayRecords: {},
      lastHourRecords: {},
      sevdaysRecords: {},
      fn: "",
      edit: "",
      type: "hour",
      unit: "",
      start: { open: false, date: null, time: "00:00" },
      end: { open: false, date: null, time: "23:59" },
      CHART,
      WIDGET,
      KWH,
      COLUMS,
      error: false,
      idx: 0,
      errorMsgs: [
        "Timespan out of range, check your data",
        "Duplicate data, check and try again",
        "Data input incorrectly, check and try again",
        "Information not available, check your data or try with other values",
      ],
      start_30d: null,
      end_30d: null,
      l_start: null,
      l_end: null,
      processing: false,
      customBar: false,
      customV: false,
      customA: false,
      customW: false,
      text: null,
      customActive: false,
      infoRetrieved: true,
      show: false,
    };
  },
  methods: {
    ...mapActions({
      updateMeterDayData: "meters/updateMeterData",
      getHistoricData: "meters/getHistoricData",
    }),
    async refresh() {
      await this.watchReadings();
      if (this.graph.name === "KWH daily") {
        this.items = ["Current Month", "7 days", "15 days", "30 days"];
      } else {
        this.items = ["Last hour", "12 hours", "24 hours"];
      }
      if (this.historic != undefined) return this.formatChartHistoric();
      if (this.graph.graph == CHART) return this.formatChartData();
      if (this.graph.graph == WIDGET) return this.formatWidgetData();
    },
    selectDate(date, mode) {
      this.$refs[mode].save(date);
      this[mode].open = false;
    },
    formatWidgetData() {
      this.data = this.dataMeter[this.dataMeter.length - 1];
    },
    async formatChartHistoric() {
      this.graph.setType(this.COLUMS);
      const { data } = await this.getHistoricData({
        id_meter: this.meter.name,
        days: 30,
      });
      let currDate = new Date();
      let currMonth = currDate.getMonth() + 1;
      let prevArray = [];
      let follArray = [];

      for (let index = 0; index < data.length; index++) {
        const element = data[index];
        if (data[index]._id.month === currMonth) follArray.push(element);
        else prevArray.push(element);
      }

      let c1 = 0;
      let c2 = 0;

      for (let i = 0; i < prevArray.length - 1; i++) {
        c1 += 1;
        if (prevArray[i]._id.day > prevArray[i + 1]._id.day) {
          for (let j = c1; j >= 1; j--) {
            if (prevArray[j]._id.day < prevArray[j - 1]._id.day) {
              let num = prevArray[j];
              prevArray[j] = prevArray[j - 1];
              prevArray[j - 1] = num;
            }
          }
        }
      }

      for (let i = 0; i < follArray.length - 1; i++) {
        c2 += 1;
        if (follArray[i]._id.day > follArray[i + 1]._id.day) {
          for (let j = c2; j >= 1; j--) {
            if (follArray[j]._id.day < follArray[j - 1]._id.day) {
              let num = follArray[j];
              follArray[j] = follArray[j - 1];
              follArray[j - 1] = num;
            }
          }
        }
      }

      let newArray = prevArray.concat(follArray);
      this.rawDataDaily = newArray;
      let array15 = [];
      let array7 = [];
      for (let index = newArray.length - 7; index < newArray.length; index++)
        if (newArray[index] != undefined) array7.push(newArray[index]);
      for (let index = newArray.length - 15; index < newArray.length; index++)
        if (newArray[index] != undefined) array15.push(newArray[index]);

      const data_formated = {
        categories: [],
        series: [{ line: "0", prop: KWH, data: [] }],
      };
      newArray.forEach((reading) => {
        let dt = new Date(
          reading._id.year,
          reading._id.month - 1,
          reading._id.day
        );
        data_formated.series.forEach((serie) => {
          serie.data.push({
            x: dt.getTime(),
            y: reading.lines[serie.line][serie.prop].toFixed(2),
          });
        });
        data_formated.categories.push(dt.toLocaleDateString());
      });
      if (data_formated.series[0].data.length === 0)
        return (this.infoRetrieved = false);
      this.infoRetrieved = true;
      this.dataAll = data_formated;
      let idx = data_formated.series[0].data.length - 1;
      this.start_30d = data_formated.series[0].data[0].x;
      this.end_30d = data_formated.series[0].data[idx].x;

      const data_15 = {
        categories: [],
        series: [{ line: "0", prop: KWH, data: [] }],
      };
      array15.forEach((reading) => {
        let dt = new Date(
          reading._id.year,
          reading._id.month - 1,
          reading._id.day
        );
        data_15.series.forEach((serie) => {
          serie.data.push({
            x: dt.getTime(),
            y: reading.lines[serie.line][serie.prop].toFixed(2),
          });
        });
        data_15.categories.push(dt.toLocaleDateString());
      });
      this.data15 = data_15;

      const data_7 = {
        categories: [],
        series: [{ line: "0", prop: KWH, data: [] }],
      };
      array7.forEach((reading) => {
        let dt = new Date(
          reading._id.year,
          reading._id.month - 1,
          reading._id.day
        );
        data_7.series.forEach((serie) => {
          serie.data.push({
            x: dt.getTime(),
            y: reading.lines[serie.line][serie.prop].toFixed(2),
          });
        });
        data_7.categories.push(dt.toLocaleDateString());
      });
      this.data7 = data_7;

      const data_curr = {
        categories: [],
        series: [{ line: "0", prop: KWH, data: [] }],
      };
      follArray.forEach((reading) => {
        let dt = new Date(
          reading._id.year,
          reading._id.month - 1,
          reading._id.day
        );
        data_curr.series.forEach((serie) => {
          serie.data.push({
            x: dt.getTime(),
            y: reading.lines[serie.line][serie.prop].toFixed(2),
          });
        });
        data_curr.categories.push(dt.toLocaleDateString());
      });
      this.datacurr = data_curr;
      if (!this.customBar) this.data = this.datacurr;
    },
    async formatChartData() {
      try {
        // console.log(this.compound);
        if (this.compound) return (this.data = this.datacomp);

        let actual_time = 0;
        const data_formated = { categories: [], series: [] };
        const data_h12 = { categories: [], series: [] };
        const data_m60 = { categories: [], series: [] };
        if (this.dayRecords) {
          this.graph.lines.forEach((line) => {
            this.graph.props.forEach((prop) => {
              data_formated.series.push({ line, prop, data: [] });
            });
          });
          this.dayRecords.data.forEach((reading) => {
            actual_time = new Date(reading.timestamp);
            data_formated.series.forEach((serie) => {
              let num = reading.lines[serie.line][serie.prop].toFixed(2);
              if (serie.prop === "watts") {
                num = (num / 1000).toFixed(2);
              }
              serie.data.push({
                x: actual_time.getTime(),
                y: num,
              });
            });
            data_formated.categories.push(
              actual_time.toLocaleTimeString().slice(0, -3)
            );
          });

          if (data_formated.series[0].data.length === 0)
            return (this.infoRetrieved = false);

          this.infoRetrieved = true;

          this.data = data_formated;

          let idx = data_formated.series[0].data.length - 1;
          this.l_start = data_formated.series[0].data[0].x;
          this.l_end = data_formated.series[0].data[idx].x;

          if (this.data.series[0].prop === "watts") {
            this.wData.wAll = data_formated;
            if (this.customW) this.data = this.wData.wCustom;
          } else if (this.data.series[0].prop === "volts") {
            this.vData.vAll = data_formated;
            if (this.customV) this.data = this.vData.vCustom;
          } else if (this.data.series[0].prop === "amps") {
            this.aData.aAll = data_formated;
            if (this.customA) this.data = this.aData.aCustom;
          }
        }
        if (this.halfDayRecords) {
          this.graph.lines.forEach((line) => {
            this.graph.props.forEach((prop) => {
              data_h12.series.push({ line, prop, data: [] });
            });
          });
          this.halfDayRecords.data.forEach((reading) => {
            actual_time = new Date(reading.timestamp);
            data_h12.series.forEach((serie) => {
              let num = reading.lines[serie.line][serie.prop].toFixed(2);
              if (serie.prop === "watts") {
                num = (num / 1000).toFixed(2);
              }
              serie.data.push({
                x: actual_time.getTime(),
                y: num,
              });
            });
            data_h12.categories.push(
              actual_time.toLocaleTimeString().slice(0, -3)
            );
          });
          if (this.data.series[0].prop === "watts") {
            this.wData.wh12 = data_h12;
          } else if (this.data.series[0].prop === "volts") {
            this.vData.vh12 = data_h12;
          } else {
            this.aData.ah12 = data_h12;
          }
        }
        if (this.lastHourRecords) {
          this.graph.lines.forEach((line) => {
            this.graph.props.forEach((prop) => {
              data_m60.series.push({ line, prop, data: [] });
            });
          });
          this.lastHourRecords.data.forEach((reading) => {
            actual_time = new Date(reading.timestamp);
            data_m60.series.forEach((serie) => {
              let num = reading.lines[serie.line][serie.prop].toFixed(2);
              if (serie.prop === "watts") {
                num = (num / 1000).toFixed(2);
              }
              serie.data.push({
                x: actual_time.getTime(),
                y: num,
              });
            });
            data_m60.categories.push(
              actual_time.toLocaleTimeString().slice(0, -3)
            );
          });
          if (this.data.series[0].prop === "watts") {
            this.wData.wm60 = data_m60;
          } else if (this.data.series[0].prop === "volts") {
            this.vData.vm60 = data_m60;
          } else {
            this.aData.am60 = data_m60;
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    setGraphData(prop, item) {
      if (prop === "kwht") {
        switch (item) {
          case "7 days": {
            this.data = this.data7;
            this.kwh.btn0 = false;
            this.kwh.btn1 = true;
            this.kwh.btn2 = false;
            this.kwh.btn3 = false;
            this.customActive = false;
            break;
          }
          case "15 days": {
            this.data = this.data15;
            this.kwh.btn0 = false;
            this.kwh.btn1 = false;
            this.kwh.btn2 = true;
            this.kwh.btn3 = false;
            this.customActive = false;
            break;
          }
          case "Current Month": {
            this.data = this.datacurr;
            this.kwh.btn0 = true;
            this.kwh.btn1 = false;
            this.kwh.btn2 = false;
            this.kwh.btn3 = false;
            this.customActive = false;
            break;
          }
          default: {
            this.data = this.dataAll;
            this.kwh.btn0 = false;
            this.kwh.btn1 = false;
            this.kwh.btn2 = false;
            this.kwh.btn3 = true;
            this.customActive = false;
            break;
          }
        }
      } else if (prop === "watts") {
        switch (item) {
          case "Last hour": {
            this.data = this.wData.wm60;
            this.w.btn0 = true;
            this.w.btn1 = false;
            this.w.btn2 = false;
            this.customActive = false;
            break;
          }
          case "12 hours": {
            this.data = this.wData.wh12;
            this.w.btn0 = false;
            this.w.btn1 = true;
            this.w.btn2 = false;
            this.customActive = false;
            break;
          }
          default: {
            this.data = this.wData.wAll;
            this.w.btn0 = false;
            this.w.btn1 = false;
            this.w.btn2 = true;
            this.customActive = false;
            break;
          }
        }
      } else if (prop === "volts") {
        switch (item) {
          case "Last hour": {
            this.data = this.vData.vm60;
            this.v.btn0 = true;
            this.v.btn1 = false;
            this.v.btn2 = false;
            this.customActive = false;
            break;
          }
          case "12 hours": {
            this.data = this.vData.vh12;
            this.v.btn0 = false;
            this.v.btn1 = true;
            this.v.btn2 = false;
            this.customActive = false;
            break;
          }
          default: {
            this.data = this.vData.vAll;
            this.v.btn0 = false;
            this.v.btn1 = false;
            this.v.btn2 = true;
            this.customActive = false;
            break;
          }
        }
      } else {
        switch (item) {
          case "Last hour": {
            this.data = this.aData.am60;
            this.a.btn0 = true;
            this.a.btn1 = false;
            this.a.btn2 = false;
            this.customActive = false;
            break;
          }
          case "12 hours": {
            this.data = this.aData.ah12;
            this.a.btn0 = false;
            this.a.btn1 = true;
            this.a.btn2 = false;
            this.customActive = false;
            break;
          }
          default: {
            this.data = this.aData.aAll;
            this.a.btn0 = false;
            this.a.btn1 = false;
            this.a.btn2 = true;
            this.customActive = false;
            break;
          }
        }
      }
    },
    async watchReadings() {
      this.dayRecords = await Readings.byMeter(
        { id: this.meter.name, key: this.meter.key },
        {
          end: new Date().getTime(),
          start: new Date().getTime() - 1000 * 60 * 60 * 24,
        }
      );
      this.halfDayRecords = await Readings.byMeter(
        { id: this.meter.name, key: this.meter.key },
        {
          end: new Date().getTime(),
          start: new Date().getTime() - 1000 * 60 * 60 * 12,
        }
      );
      this.lastHourRecords = await Readings.byMeter(
        { id: this.meter.name, key: this.meter.key },
        {
          end: new Date().getTime(),
          start: new Date().getTime() - 1000 * 60 * 60 * 1,
        }
      );
    },
    retrieveData(unit) {
      this.show = false;
      this.edit = true;
      this.unit = unit;
      this.type = unit === "kwht" ? "day" : "hour";
      this.start.date = null;
      this.end.date = null;
    },
    async setDates() {
      this.processing = true;
      this.error = false;
      this.show = true;

      if (this.unit === "kwht") {
        let ss = moment(this.start.date).valueOf();
        let es = moment(this.end.date).valueOf();
        let so = moment(this.start_30d).valueOf();
        let eo = moment(this.end_30d).valueOf();
        let diff = 32 * 24 * 60 * 60 * 1000;

        if (es > eo || es - ss > diff) {
          this.processing = false;
          this.idx = 0;
          return (
            (this.show = false),
            (this.error = true),
            await this.sleep(2000).then(() => {
              this.error = false;
            })
          );
        } //Out of range, only if today is end date //ss < so
        if (ss === es) {
          this.processing = false;
          this.idx = 1;
          return (
            (this.show = false),
            (this.error = true),
            await this.sleep(2000).then(() => {
              this.error = false;
            })
          );
        } //Same data
        if (es <= ss) {
          this.processing = false;
          this.idx = 2;
          return (
            (this.show = false),
            (this.error = true),
            await this.sleep(2000).then(() => {
              this.error = false;
            })
          );
        } //Data input incorrectly
        if (es === NaN || ss === NaN || so === NaN || eo === NaN) {
          this.processing = false;
          this.idx = 3;
          return (
            (this.show = false),
            (this.error = true),
            await this.sleep(2000).then(() => {
              this.error = false;
            })
          );
        } //Data not available

        const { data } = await this.getHistoricData({
          id_meter: this.meter.name,
          start: new Date(ss).getTime(),
          end: new Date(es).getTime() + 24 * 60 * 60 * 1000,
        });
        data.forEach((element) => {
          let dt = new Date(
            element._id.year,
            element._id.month - 1,
            element._id.day
          );
          element.milis = dt.getTime();
        });

        let days = data.sort((a, b) => (a.milis > b.milis ? 1 : -1));
        const data_retrieved = {
          categories: [],
          series: [{ line: "0", prop: KWH, data: [] }],
        };
        days.forEach((reading) => {
          let dt = new Date(
            reading._id.year,
            reading._id.month - 1,
            reading._id.day
          );
          data_retrieved.series.forEach((serie) => {
            serie.data.push({
              x: dt.getTime(),
              y: reading.lines[serie.line][serie.prop].toFixed(2),
            });
          });
          data_retrieved.categories.push(dt.toLocaleDateString());
        });

        this.data = data_retrieved;
        this.customBar = true;
        this.kwh.btn0 = false;
        this.customActive = true;
        this.text = `${moment(this.start.date).format("L")} to ${moment(
          this.end.date
        ).format("L")}`;

        await this.sleep(2000).then(() => {
          this.processing = false;
        });
      } else {
        let selD = moment(this.start.date).valueOf();
        let hcS = this.start.time.split(":").map((t) => parseInt(t));
        let selHS = hcS[0] * 3600 * 1000 + hcS[1] * 60 * 1000;
        let hcE = this.end.time.split(":").map((t) => parseInt(t));
        let selHE = hcE[0] * 3600 * 1000 + hcE[1] * 60 * 1000;
        let start_hour = selD + selHS;
        let end_hour = selD + selHE;
        let t_span = await Readings.byMeter(
          { id: this.meter.name, key: this.meter.key },
          { end: end_hour + 60 * 1000, start: start_hour - 60 * 1000 }
        );

        let so = moment(this.l_start).valueOf() - 90 * 24 * 60 * 60 * 1000; //Límite 3 meses
        let eo = moment(this.l_end).valueOf(); //Límite

        if (this.start.time === this.end.time) {
          this.processing = false;
          this.idx = 1;
          return (
            (this.show = false),
            (this.error = true),
            await this.sleep(2000).then(() => {
              this.error = false;
            })
          );
        }
        if (this.start.time > this.end.time) {
          this.processing = false;
          this.idx = 2;
          return (
            (this.show = false),
            (this.error = true),
            await this.sleep(2000).then(() => {
              this.error = false;
            })
          );
        }
        if (
          t_span.data.length === 0 ||
          t_span === undefined ||
          t_span === null ||
          so === NaN ||
          eo === NaN
        ) {
          this.processing = false;
          this.idx = 3;
          return (
            (this.show = false),
            (this.error = true),
            await this.sleep(2000).then(() => {
              this.error = false;
            })
          );
        }
        const data_retrieved = { categories: [], series: [] };
        let actual_time = 0;

        this.graph.lines.forEach((line) => {
          this.graph.props.forEach((prop) => {
            data_retrieved.series.push({ line, prop, data: [] });
          });
        });
        t_span.data.forEach((reading) => {
          actual_time = new Date(reading.timestamp);
          data_retrieved.series.forEach((serie) => {
            let num = reading.lines[serie.line][serie.prop].toFixed(2);
            if (serie.prop === "watts") {
              num = (num / 1000).toFixed(2);
            }
            serie.data.push({ x: actual_time.getTime(), y: num });
          });
          data_retrieved.categories.push(
            actual_time.toLocaleTimeString().slice(0, -3)
          );
        });

        this.text = `${moment(this.start.date).format("L")} @ ${
          this.start.time
        }-${this.end.time}`;
        if (this.unit === "watts") {
          this.customW = true;
          this.customActive = true;
          this.wData.wCustom = data_retrieved;
          this.data = data_retrieved;
          this.w.btn2 = false;
        } else if (this.unit === "volts") {
          this.customV = true;
          this.customActive = true;
          this.vData.vCustom = data_retrieved;
          this.data = data_retrieved;
          this.v.btn2 = false;
        } else {
          this.customA = true;
          this.customActive = true;
          this.aData.aCustom = data_retrieved;
          this.data = data_retrieved;
          this.a.btn2 = false;
        }
        await this.sleep(2000).then(() => {
          this.processing = false;
        });
      }
      this.edit = false;
      this.show = false;
    },
    reset() {
      this.edit = false;
      this.error = false;
      this.start.time = "00:00";
      this.end.time = "12:00";
    },
    sleep(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
  },
  created() {
    this.refresh();
    // this.fn = setInterval(() => {
    //     this.refresh()
    //  }, 60 * 1000)
  },
  // mounted() {
  //     console.log(this.datacomp)
  // },
  destroyed() {
    clearInterval(this.fn);
  },
  // watch: {
  //     datafront(newVal, oldVal){
  //         console.log(newVal);
  //         // this.formatChartData()
  //     },
  //     deep: true
  // }
};
</script>

<style scoped>
div.a {
  text-align: center;
}
.dropdown {
  height: 45px;
  position: relative;
  right: 5px;
}
.shake {
  animation: shake 0.82s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
  transform: translate3d(0, 0, 0);
  backface-visibility: hidden;
  perspective: 1000px;
}
@keyframes shake {
  10%,
  90% {
    transform: translate3d(-1px, 0, 0);
  }

  20%,
  80% {
    transform: translate3d(2px, 0, 0);
  }

  30%,
  50%,
  70% {
    transform: translate3d(-4px, 0, 0);
  }

  40%,
  60% {
    transform: translate3d(4px, 0, 0);
  }
}
.only {
  position: relative;
  top: -50px;
}
</style>
